export enum UploadedImagesActions {
  UPLOAD_IMAGE = 'UPLOAD_IMAGE',
  REMOVE_IMAGE = 'REMOVE_IMAGE',
}
